/**
 * Why a public options page (flights, stays) could not show its option set.
 *
 * Only a 404 means the set is gone: the backend answers 404 for a token that
 * does not exist or whose set passed its 24-hour lifetime. Any other failure
 * (no network, a rate limit, a server error) leaves the set intact, so telling
 * the owner the link "has expired" sent them back to the assistant for a fresh
 * search they did not need (GET-16564).
 */
export type OptionSetLoadFailure = 'expired' | 'unreachable'

export function optionSetLoadFailure(status: number | undefined): OptionSetLoadFailure {
  return status === 404 ? 'expired' : 'unreachable'
}
